import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-new-mexico-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./new-mexico-state-form.component.html",
  styleUrl: "./new-mexico-state-form.component.scss",
})
export class NewMexicoStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
